import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';

const FlagTabs = (props) => {
  const { tabs } = props;
  const location = useLocation();
  const url = location.pathname;

  return (
    <StyledSection>
      <Wrapper>
        <TabsWrapper>
          {tabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <Tab
                key={tab.to}
                to={tab.to}
                url={url}
                activeStyle={{
                  borderColor: 'var(--purple)',
                  color: 'var(--purple)'
                }}
              >
                <Icon />
                <StyledTitle> {tab.title}</StyledTitle>
              </Tab>
            );
          })}
        </TabsWrapper>
      </Wrapper>
    </StyledSection>
  );
};

const TabsWrapper = styled.nav`
  align-items: center;
  border-bottom: 1px solid rgb(220, 223, 232);
  display: none;
  ${({ theme }) => `
    @media ${theme.largeUp} {
      display: flex;
    }
`}
`;

const StyledTitle = styled.p`
  margin-left: 10px;
`;

const StyledSection = styled(Section)`
  margin-bottom: 60px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: start;
  flex-wrap: wrap;
  justify-content: center;
`;

const Tab = styled(Link)`
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  margin-bottom: -1px;
  display: flex;
  &:first-of-type {
    margin-left: 0px;
  }

  border-bottom: 2px solid transparent;
  cursor: pointer;
  padding-bottom: 25px;

  border-color: ${(url) => {
    const baseUrl = url.url;
    const tabUrl = url.to;
    return baseUrl === '/pricing' && tabUrl === '/pricing/us'
      ? 'var(--purple)'
      : '';
  }};
  }

  &:focus,
  &:hover,
  &:active {
    color: var(--purple);
    border-color: var(--purple);
    outline: none;
  }


`;

export default FlagTabs;
